angular.element(document).ready(function() {
    setTimeout(function() {
        angular.bootstrap(document.documentElement, ['WB.App'], {
            strictDi: true
        });
    });
});
